import { useLayoutEffect, useRef, useState } from 'react';

export default function useViewportMenuPosition(open, x, y, aboveY = y) {
    const ref = useRef(null);
    const [position, setPosition] = useState({});

    useLayoutEffect(() => {
        const menu = ref.current;
        if (!open || !menu) return;

        function updatePosition() {
            const margin = 12;
            const maxHeight = Math.max(0, window.innerHeight - margin * 2);
            const maxWidth = Math.max(0, window.innerWidth - margin * 2);
            const rect = menu.getBoundingClientRect();
            const height = Math.min(rect.height, maxHeight);
            const width = Math.min(rect.width, maxWidth);
            const preferredTop = y + height > window.innerHeight - margin ? aboveY - height : y;
            const next = {
                position: 'fixed',
                left: Math.max(margin, Math.min(x, window.innerWidth - width - margin)),
                top: Math.max(margin, Math.min(preferredTop, window.innerHeight - height - margin)),
                maxHeight,
                maxWidth,
                overflow: menu.scrollHeight > maxHeight ? 'auto' : 'visible'
            };
            setPosition(previous => (
                Object.keys(next).every(key => previous[key] === next[key]) ? previous : next
            ));
        }

        updatePosition();
        const observer = new ResizeObserver(updatePosition);
        observer.observe(menu);
        window.addEventListener('resize', updatePosition);
        return () => {
            observer.disconnect();
            window.removeEventListener('resize', updatePosition);
        };
    }, [open, x, y, aboveY]);

    return { ref, position };
}
